module.exports = __webpack_public_path__ + "static/img/bronxbrewery.b0d4210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bronxbrewery.png
// module id = 289
// module chunks = 1